import { Audience, AudienceType } from "@intentsify/types";
import { isPopulatedArray } from "@intentsify/utils";
import { Row, Table } from "@tanstack/react-table";
import {
  Actions,
  EmptyCell,
  IndeterminateCheckbox,
  L_COLUMN_WIDTH,
  M_COLUMN_WIDTH,
  XS_COLUMN_WIDTH,
} from "components";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router";
import { UpdateAudienceDefinition } from "../../UpdateAudience";

const ActionsCell = ({ audienceId }: { audienceId: number }) => {
  const navigate = useNavigate();

  const items = audienceId
    ? [
        {
          label: "Edit",
          icon: <FiEdit />,
          onClick: () =>
            navigate(
              UpdateAudienceDefinition.navigate({
                id: audienceId,
              })
            ),
        },
      ]
    : [];
  return audienceId ? <Actions items={items} /> : <EmptyCell />;
};

export const columns = [
  {
    id: "select",
    header: ({ table }: { table: Table<Audience> }) => {
      const rows = table.getRowModel().rows;

      const onChange = () => {
        rows.forEach((row) => row.toggleSelected());
      };

      const allChecked = rows.every((row) => row.getIsSelected());

      const someChecked = rows.some((r) => r.getIsSelected());
      const indeterminate = someChecked && !allChecked;

      return (
        <IndeterminateCheckbox
          {...{
            checked: allChecked && isPopulatedArray(rows),
            indeterminate,
            onChange,
          }}
        />
      );
    },
    cell: ({ row }: { row: Row<Audience> }) => {
      return (
        <IndeterminateCheckbox
          {...{
            checked: row.getIsSelected(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
          }}
        />
      );
    },
  },
  {
    header: "Segment Name",
    accessorKey: "fullSegmentName",
    size: XS_COLUMN_WIDTH,
  },
  {
    header: "Audience",
    accessorKey: "audienceType",
    size: M_COLUMN_WIDTH,
    cell: ({ row }: { row: Row<Audience> }) => {
      return AudienceType[row.original.audienceType];
    },
  },
  {
    header: "Type",
    accessorKey: "audienceTarget",
    enableSorting: false,
    size: L_COLUMN_WIDTH,
  },
  {
    header: "Last Update",
    accessorKey: "updatedAt",
    enableSorting: false,
    size: L_COLUMN_WIDTH,
  },
  {
    header: "Actions",
    cell: ({ row }: { row: Row<Audience> }) => {
      return <ActionsCell audienceId={row.original.id} />;
    },
  },
];
